import { useEffect, type RefObject } from 'react';

/**
 * Calls `handler` when a pointer press lands outside `ref`.
 *
 * Listens on `mousedown` rather than `click` so a menu closes as the press
 * starts, before the element under the cursor has a chance to move.
 */
export const useClickOutside = <T extends HTMLElement>(
  ref: RefObject<T | null>,
  handler: () => void,
  enabled = true,
) => {
  useEffect(() => {
    if (!enabled) return;

    const onPointerDown = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) handler();
    };

    document.addEventListener('mousedown', onPointerDown);
    return () => document.removeEventListener('mousedown', onPointerDown);
  }, [ref, handler, enabled]);
};
